import { apiClient } from '@utils';

export const useRetrieveReports = () => {
  const result = apiClient.chart.retrieveReports.useQuery(['retrieve-reports'], { params: { asAdmin: undefined } });
  return { ...result, data: result.data?.body?.data };
};
